import { useState, useCallback } from 'react';
import { useFormContext, UseFormReturn } from 'react-hook-form';

// Define the shape of the address data coming from the autocomplete component
interface AddressData {
  address1: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  lon: number;
  lat: number;
}

interface UseFormAddressProps {
  methodss: UseFormReturn<any>;
}

export const useFormAddress = () => {
  // const { setValue, resetField } = methods;

  const { setValue, resetField } = useFormContext();

  /**
   * Receives a valid, selected address from the autocomplete component,
   * updates the form, and sets the verified flag.
   */
  const handleAddressSelected = useCallback(
    (addressData: AddressData) => {
      setValue('address1', addressData.address1, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('city', addressData.city, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('state', addressData.state, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('country', addressData.country, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('zipcode', addressData.zipcode, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('lon', addressData.lon, {
        shouldValidate: true,
        shouldDirty: true,
      });
      setValue('lat', addressData.lat, {
        shouldValidate: true,
        shouldDirty: true,
      });
    },
    [setValue],
  );

  /**
   * This is called when the user focuses the address input to search again.
   * It resets the verification status and clears all stale address data.
   */
  const handleAddressInputFocus = useCallback(() => {
    resetField('address1');
    resetField('address2');
    resetField('city');
    resetField('state');
    resetField('country');
    resetField('zipcode');
    resetField('lon');
    resetField('lat');
  }, [resetField]);

  return {
    handleAddressSelected,
    handleAddressInputFocus,
  };
};
